import React from 'react';
import DiceRoller from './components/DiceRoller';
import './App.css';

function App() {
  return (
    <div className="App">
      <DiceRoller />
    </div>
  );
}

export default App; 